import { render } from "./PWayHome.vue?vue&type=template&id=bd6f7b40&scoped=true"
import script from "./PWayHome.vue?vue&type=script&lang=js"
export * from "./PWayHome.vue?vue&type=script&lang=js"

import "./PWayHome.vue?vue&type=style&index=0&id=bd6f7b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6f7b40"]])

export default __exports__